import React, { useEffect } from "react";
import "./App.css";
import { VirtualPath } from "./VirtualPath";
import { AuthProvider } from "./context/AuthContext";
import ResizeObserverComponent from "./components/ResizeObserverComponent";

const App = () => {
  useEffect(() => {
    document.title = "Employees";
  }, []);

  return (
    <div id="container" className="container" style={{ width: "99%" }}>
      <AuthProvider>
        <VirtualPath />
        <ResizeObserverComponent />
      </AuthProvider>
    </div>
  );
};

export default App;
